// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { zIndexes } from 'frontend_core/dist/styles/variables'

type PropTypes = {
  addedFavoriteListName?: ?string,
  favorited: boolean,
  showingFavoriteListTooltip: boolean,
  onClick: Function,
}

const AddFavoriteSp = styled.div`
  position: 'relative';
`

const FavoriteListTooltip = styled.div`
  position: absolute;
  z-index: ${zIndexes.fav};
  right: 17%;
  left: 220px;
  width: 150px;
  top: 50px;
`

const SpacesSideFavoriteBaloon = styled.div`
  font-size: 12px;
  background-color: #ffffff;
  position: relative;
  border-radius: 3px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  text-align: center;
  &::before {
    background-color: #ffffff;
    position: absolute;
    content: ' ';
    height: 15px;
    width: 15px;
    transform: rotate(45deg);
    top: -7px;
    right: 10%;
    margin-left: -8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }
  &::after {
    background-color: #ffffff;
    position: absolute;
    content: ' ';
    height: 13px;
    width: 90%;
    top: 0px;
    left: 5%;
  }
`

const SpaceSideFavoriteBaloonText = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 13px;
`
const SpaceHeadFavorite = styled.a`
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 20px;
  ${props =>
    props.isFavorited
      ? css`
          color: #f06060;
        `
      : css`
          color: #666;
        `};
`

export default (props: PropTypes) => {
  const {
    addedFavoriteListName,
    favorited,
    onClick,
    showingFavoriteListTooltip,
  } = props
  return (
    <AddFavoriteSp>
      <SpaceHeadFavorite
        onClick={onClick}
        className={`pc-hide__sm-show`}
        isFavorited={favorited}
      >
        <i className="fa fa-heart" />
      </SpaceHeadFavorite>
      {showingFavoriteListTooltip && (
        <FavoriteListTooltip>
          <SpacesSideFavoriteBaloon>
            <SpaceSideFavoriteBaloonText>
              {addedFavoriteListName}
            </SpaceSideFavoriteBaloonText>
          </SpacesSideFavoriteBaloon>
        </FavoriteListTooltip>
      )}
    </AddFavoriteSp>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/room/AddFavoriteSp/index.jsx